export const noop = () => {
  // does nothing all day, all night :)
}
